import { RootState } from '@/App/store';

export const selectSystemLocale = (state: RootState) => state.config.systemLocale;
